module.exports = __webpack_public_path__ + "img/su.4f13ff6a.png";